/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_My_RecruitsInputs */



/**
* | output |
* | --- |
* | "My recruits" |
*
* @param {User_List_Filter_My_RecruitsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_my_recruits = /** @type {((inputs?: User_List_Filter_My_RecruitsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_My_RecruitsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mes recrues")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mis reclutas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Meus recrutas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le mie reclute")
	return /** @type {LocalizedString} */ ("My recruits")
});